const LoadingState = () => <p>Loading...</p>;

export default LoadingState;